<template>
    <div class="service-content-item flex-initial text-white mb-spc16 xl:w-auto lg:w-auto md:w-1/3">
        <div class="service-content-icon mb-spc16">
            <img class="h-spc24" :src="service.icon" alt="Icon">
        </div>
        <div class="service-content">
            <h2 class="text-xl font-medium mb-5">
                {{service.title}}
            </h2>
            <p class="text-base opacity-50 whitespace-pre-line leading-6 font-normal">
                {{service.content}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ServiceOneItems",
        props: ['service']
    }
</script>

<style scoped>

</style>